import { NavigationRoutes } from 'common/constants';
import { themedStyled } from 'common/styles/styletron.theme';
import HOCInput from 'components/common/hoc-input';
import Separator from 'components/common/separator';
import { Input } from 'components/elements';
import { Button } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useNavigation from 'hooks/use-navigation';
import {
  CardSection,
  FullContainer,
  HalfContainer,
  SectionContainer as RawSectionContainer,
} from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';

export default function BalanceAdjustmentDetail() {
  const { t } = useTranslation();
  const { navigate } = useNavigation();

  return (
    <CardSection style={{ paddingBottom: 0 }}>
      <SectionContainer>
        <Text variant="HeadingXSmall">
          {t('common:detail_extra', { extra: t('common:balance_adjustment') })}
        </Text>
        <HOCInput keys={['approvalable']}>
          {(value) => (
            <Button
              buttonType="secondary"
              onClick={() =>
                navigate(NavigationRoutes.BalanceAdjustmentsView, {
                  id: value.approvalable.id,
                })
              }
            >
              {t('common:view_details')}
            </Button>
          )}
        </HOCInput>
      </SectionContainer>
      <Separator gap={16} />
      <SectionContainer>
        <HalfContainer>
          <Input
            type="date-time"
            name="approvalable.date"
            label={t('common:transaction_at')}
          />
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.number"
            label={t('common:number')}
          />
        </HalfContainer>
      </SectionContainer>
      <FullContainer>
        <Input
          type="text"
          name="approvalable.description"
          label={t('common:description')}
        />
      </FullContainer>
      <SectionContainer>
        <HalfContainer>
          <HOCInput keys={['approvalable.balanceableType']}>
            {(_value) => {
              const value = _value['approvalable.balanceableType'];
              return (
                <Input
                  type="text"
                  name="approvalable.balanceableName"
                  label={t(`common:${value?.toLowerCase()}`)}
                />
              );
            }}
          </HOCInput>
        </HalfContainer>
        <HalfContainer>
          <Input
            type="text"
            name="approvalable.amount"
            label={t('common:amount')}
          />
        </HalfContainer>
      </SectionContainer>
    </CardSection>
  );
}

const SectionContainer = themedStyled(RawSectionContainer, {
  width: '100%',
});
